export default __webpack_public_path__ + "static/media/Inter-Medium.456aa398.woff";